export const ADD_FLASH_MESSAGES = 'ADD_FLASH_MESSAGES'
export const REMOVE_FLASH_MESSAGE = 'REMOVE_FLASH_MESSAGE'
export const RESET_FLASH_MESSAGES = 'RESET_FLASH_MESSAGES'
